import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Legend } from 'recharts';

const FNOLPendingActivityChart = ({ data, loading }) => {
    // Transform API data to chart format
    const chartData = data && data.activities 
        ? data.activities.map(activity => ({
            name: activity.label,
            value: activity.count
        }))
        : [
            { name: 'Data Handling', value: 0 },
            { name: 'Validation', value: 0 },
            { name: 'Triage', value: 0 },
            { name: 'Claim Setup', value: 0 },
        ];

    if (loading) {
        return (
            <div className="h-[380px] flex flex-col items-center justify-center">
                <h2 className="text-xl font-bold text-gray-900 mb-1">FNOL By Pending Activity</h2>
                <p className="text-sm text-gray-500 mb-6 font-medium">Completed FNOLs by Activity Stage</p>
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }
    return (
        <div className="h-full flex flex-col items-center w-full">
            <h2 className="text-xl font-bold text-gray-900 mb-1">FNOL By Pending Activity</h2>
            <p className="text-sm text-gray-500 mb-3 font-medium">Completed FNOLs by Activity Stage</p>
            <div className="w-full h-[380px]">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={chartData}
                        margin={{
                            top: 20,
                            right: 10,
                            left: 20,
                            bottom: 30,
                        }}
                        barSize={80}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                        <XAxis
                            dataKey="name"
                            tick={{ fontSize: 11, fill: '#374151' }}
                            axisLine={true}
                            tickLine={false}
                            dy={10}
                        />
                        <YAxis
                            domain={[0, 50]}
                            tick={{ fontSize: 11, fill: '#374151' }}
                            axisLine={true}
                            tickLine={false}
                            label={{
                                value: 'Number of Completed FNOLs',
                                angle: -90,
                                position: 'insideLeft',
                                style: { textAnchor: 'middle', fontSize: '11px', fill: '#6B7280' },
                                dx: -10
                            }}
                        />
                        <Tooltip cursor={{ fill: 'transparent' }} />
                        <Legend
                            layout="horizontal"
                            verticalAlign="bottom"
                            align="center"
                            iconType="square"
                            wrapperStyle={{ paddingTop: '8px' }}
                            formatter={(value) => <span className="text-gray-700 font-medium ml-1">{value}</span>}
                        />
                        <Bar
                            dataKey="value"
                            fill="#93C5FD"
                            name="Completed"
                            radius={[4, 4, 0, 0]}
                        >
                            <LabelList
                                dataKey="value"
                                position="top"
                                style={{ fill: '#374151', fontSize: '12px', fontWeight: 500 }}
                                offset={5}
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default FNOLPendingActivityChart;
